import React from 'react';
import './SignUpSection.css';

const SignUpSection: React.FC = () => {
  return (
    <section className="signup-section">
      <div className="signup-background">
        <div className="signup-container">
          <div className="signup-content">
            <div className="signup-text-content">
              <h2 className="signup-heading">Sign up for free today</h2>
              <p className="signup-description">
                Celebrate the joy of accomplishment with an app designed to track your progress and motivate your efforts.
              </p>
            </div>
            
            <div className="signup-actions">
              <button className="signup-btn primary">
                Get for free
              </button>
              <button className="signup-btn secondary">
                Learn more
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignUpSection; 